<template>

  <report-panel icon="$vertical" title="Rollup by Vertical" :loading="loading">

    <v-table>
      <thead>
        <tr>
          <th scope="col">Vertical</th>
          <th scope="col" class="text-end">Transactions</th>
          <th scope="col" class="text-end">Gross Revenue</th>
          <th scope="col" class="text-end">Net Revenue</th>
          <th scope="col" class="text-end">Commission</th>
          <th scope="col" class="text-end">Average Daily Rate</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="Object.keys(rollups).length === 0">
          <td colspan="6" class="text-center">
            No data available.
          </td>
        </tr>
        <tr v-for="[vertical, rollup] in Object.entries(rollups)">
          <td>{{ VerticalRegistry.getTitle(vertical) }}</td> <!-- TODO: i18n -->
          <td class="text-end">{{ rollup.transactions }}</td>
          <td class="text-end">{{ $n(rollup.grossRevenue, 'currency') }}</td>
          <td class="text-end">{{ $n(rollup.netRevenue, 'currency') }}</td>
          <td class="text-end">{{ $n(rollup.commission, 'currency') }}</td>
          <td class="text-end">{{ $n(rollup.averageDailyRate, 'currency') }}</td>
        </tr>
      </tbody>
    </v-table>

  </report-panel>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import ReportPanel from './ReportPanel.vue'
import VerticalRegistry from '../../../../verticals/VerticalRegistry'
import type { ReportingDateSummaries } from '../../../../services/api-clients/ReportingApi'
import type { BreakdownMode } from '../types'

interface Props {
  loading: boolean
  mode: BreakdownMode
  dateSummaries: ReportingDateSummaries
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
})

interface Rollup {
  transactions: number
  grossRevenue: number
  netRevenue: number
  commission: number
  averageDailyRate: number
}

const rollups = computed(() => {

  const output: {[key: string]: Rollup} = {}

  const template: Rollup = {
    transactions: 0,
    grossRevenue: 0,
    netRevenue: 0,
    commission: 0,
    averageDailyRate: 0,
  }

  // calculate everything except for averageDailyRate
  Object.values(props.dateSummaries).forEach((summary) => {

    Object.entries(summary.as_transaction_date.transactions.by_vertical).forEach(([vertical, transactions]) => {
      if (!(vertical in output)) {
        output[vertical] = {...template}
      }
      output[vertical].transactions += transactions
    })

    Object.entries(summary.as_transaction_date.gross_revenue.by_vertical).forEach(([vertical, grossRevenue]) => {
      if (!(vertical in output)) {
        output[vertical] = {...template}
      }
      output[vertical].grossRevenue += grossRevenue
    })

    Object.entries(summary.as_transaction_date.net_revenue.by_vertical).forEach(([vertical, netRevenue]) => {
      if (!(vertical in output)) {
        output[vertical] = {...template}
      }
      output[vertical].netRevenue += netRevenue
    })

    Object.values(output).forEach((outputItem) => {
      outputItem.commission = outputItem.grossRevenue - outputItem.netRevenue
    })      

  })

  // calculate averageDailyRate
  Object.values(output).forEach((outputItem) => {
    outputItem.averageDailyRate = outputItem.transactions ? outputItem.grossRevenue / outputItem.transactions : 0
  })

  return output

})

</script>
